import { render, staticRenderFns } from "./purchaseCheque.vue?vue&type=template&id=7161dd8c&"
import script from "./purchaseCheque.vue?vue&type=script&lang=js&"
export * from "./purchaseCheque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports